module.exports = __webpack_public_path__ + "static/media/401-unauthorized-error.d27d3f15.jpg";